import { toast } from "react-toastify";
import { format } from "date-fns";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { createContext, useContext, useState } from "react";
//geração de documento (docx)
import PizZip from "pizzip";
// import { saveAs } from "file-saver";
import Docxtemplater from "docxtemplater";
import expressionParser from "docxtemplater/expressions";
//services
import { getContractInterval } from "../services/CreateAccount/getContractInterval";
import { postCreateAccount } from "../services/CreateAccount/postCreateAccount";
import { getValidateCupom } from "../services/CreateAccount/getValidateCupom";
import { getLocaleMaps } from "../services/CreateAccount/getLocaleMaps";
//context
const CreateAccountContext = createContext();

export function CreateAccountProvider({ children }) {
  // states
  const form = useForm();
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [cupom, setCupom] = useState("");
  const [bestDay, setBestDay] = useState(null);
  const [loading, setLoading] = useState(false);
  const [contract, setContract] = useState(null);
  const [pixDataQR, setPixDataQR] = useState(null);
  const [pixClient, setPixClient] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [errorCupom, setErrorCupom] = useState(false);
  const [typeInterval, setTypeInterval] = useState(null);
  const [baseDataForm, setBaseDataForm] = useState(null);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [creditCardClient, setCreditCardClient] = useState(null);
  const [visiblePixPayment, setVisiblePixPayment] = useState(false);
  const [creditCardSelected, setCreditCardSelected] = useState(null);
  const [visiblePaymentMethods, setVisiblePaymentMethods] = useState(true);
  const [cardState, setCardState] = useState({
    card_number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
  });
  const [cardInstallment, setCardInstallment] = useState({
    card_number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
  });
  const [cardMonthly, setCardMonthly] = useState({
    card_number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
  });

  // const handleInputChange = (name, value) => {
  //   setCardState((prev) => ({ ...prev, [name]: value }));
  // };

  const handleInputChange = (name, value) => {
    if (name === "expiry") {
      const [month, day] = value.split("/");
      if (
        month &&
        (parseInt(month, 10) > 12 ||
          (month !== "0_" && parseInt(month, 10) < 1))
      ) {
        setCardState((prevState) => ({
          ...prevState,
          expiry: "__/__",
        }));
        return;
      } else {
        setCardState((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setCardState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleInputFocus = (name) => {
    setCardState((prev) => ({ ...prev, focus: name }));
  };

  const handleInstallmentChange = (name, value) => {
    setCardInstallment((prev) => ({ ...prev, [name]: value }));
  };

  const handleInstallmentFocus = (name) => {
    setCardInstallment((prev) => ({ ...prev, focus: name }));
  };

  const handleMonthlyChange = (name, value) => {
    setCardMonthly((prev) => ({ ...prev, [name]: value }));
  };

  const handleMonthlyFocus = (name) => {
    setCardMonthly((prev) => ({ ...prev, focus: name }));
  };

  const checkPasswordStrength = (password) => {
    const minLength = 8;
    const regexLowerCase = /[a-z]/;
    const regexUpperCase = /[A-Z]/;
    const regexDigit = /\d/;
    const regexSpecialChar = /[@$!%*?&#_+\-=/]/;
    if (password.length < minLength) {
      return "fraca";
    }
    let strength = 0;
    if (regexLowerCase.test(password)) strength++;
    if (regexUpperCase.test(password)) strength++;
    if (regexDigit.test(password)) strength++;
    if (regexSpecialChar.test(password)) strength++;
    if (strength < 3) {
      return "fraca";
    } else if (strength === 3) {
      return "média";
    } else {
      return "forte";
    }
  };

  const onSubmit = async (data) => {
    // console.log(data);
    try {
      const response = await getLocaleMaps(
        `${data.address}, ${data.num}, ${data.neighborhood}, ${data.city}, ${data.state}`
      );
      data.lat = response.results[0].geometry.location.lat;
      data.lng = response.results[0].geometry.location.lng;
    } catch (error) {
      console.error("Erro ao buscar localização:", error);
    }

    setBaseDataForm(data);
    localStorage.setItem("formData", JSON.stringify(data));
    for (
      let index = 0;
      index < data?.name.filter((n) => n !== undefined)?.length;
      index++
    ) {
      const n = data.name[index];
      const nameParts = n.trim().split(/\s+/);

      if (nameParts.length < 2) {
        toast.error("Por favor, insira um nome completo.");
        form.setError(`name.${index}`, {
          type: "validate",
          message: "Por favor, insira um nome completo.",
        });
        return;
      }

      const lastName = nameParts[nameParts.length - 1];
      if (lastName.length <= 2) {
        toast.error("O sobrenome deve ter mais que 2 caracteres.");
        form.setError(`name.${index}`, {
          type: "validate",
          message: "O sobrenome deve ter mais que 2 caracteres.",
        });
        return;
      }
    }
    const isValid = /\(\d{2}\)\s9/.test(data.phone_enterprise);
    if (!isValid) {
      toast.error("Celular inválido.");
      return;
    }
    const senha = checkPasswordStrength(data.password);
    if (senha === "fraca" || senha === "média") {
      toast.error(`Senha ${senha}`);
      return;
    }
    setActiveIndex(1);
  };

  const savePlan = async (plan) => {
    // console.log(plan);
    setBestDay(null);

    setPlan(plan);
    if (plan.interval.interval === "month")
      setTypeInterval({ type: "month", id: plan.interval.id });
    if (plan.interval.interval === "year")
      setTypeInterval({ type: "year", id: plan.interval.id });
    try {
      await getContractInterval(plan.plan.id, plan.interval.id);
      // setActiveIndex(2);
    } catch (error) {
      // toast.error("Oops algo deu errado! Tente novamente, ou escolha outro plano.");
      // console.log(error.message);
    }
    setActiveIndex(2);
  };

  const isFormIncomplete = (formData) => {
    return Object.values(formData).some(
      (value) => value === null || value === ""
    );
  };

  const handleSubmit = async () => {
    //    console.log(plan);
    //    console.log(contract);
    //    console.log(cardState);
    //    console.log(pixClient);
    //    console.log(cardMonthly);
    //    console.log(baseDataForm);
    //    console.log(cardInstallment);
    //    console.log(creditCardClient);
    //    console.log(form.getValues());

    setLoadingButton(true);

    const isValidCPF = (doc) => {
      const cleanedDoc = doc.replace(/\D/g, "");
      return cleanedDoc.length === 11;
    };

    const isValidCNPJ = (doc) => {
      const cleanedDoc = doc.replace(/\D/g, "");
      return cleanedDoc.length === 14;
    };

    const getDocType = (doc) => {
      if (isValidCPF(doc)) return 1;
      if (isValidCNPJ(doc)) return 2;
      return null;
    };

    const getNextMonthDate = (day) => {
      const today = new Date();
      const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      const lastDayOfNextMonth = new Date(
        nextMonth.getFullYear(),
        nextMonth.getMonth() + 1,
        0
      ).getDate();

      const targetDay = Math.min(day, lastDayOfNextMonth);

      nextMonth.setDate(targetDay);
      return nextMonth;
    };

    if (
      !baseDataForm ||
      isFormIncomplete({
        doc: baseDataForm.doc_enterprise,
        name: baseDataForm.name_enterprise,
        email: baseDataForm.email_enterprise,
        phone: baseDataForm.phone_enterprise,
        userDoc: baseDataForm?.doc[0],
        userName: baseDataForm?.name[0],
        userEmail: baseDataForm?.email[0],
        userPassword: baseDataForm?.password,
      })
    ) {
      toast.warning("Preencha os dados de cadastro");
      setActiveIndex(0);
      setLoadingButton(false);
      return;
    }

    const isCardStateEmpty = Object.values(cardState).every(
      (value) => value === ""
    );
    const isPixClientNull = pixClient === null;
    const isCardMonthlyEmpty = Object.values(cardMonthly).every(
      (value) => value === ""
    );

    if (isCardStateEmpty && isPixClientNull && isCardMonthlyEmpty) {
      toast.warning("Por favor, adicione os dados para pagamento!");
      setLoadingButton(false);
      return;
    }

    if (!plan) {
      toast.warning("Por favor, selecione um plano!");
      setLoadingButton(false);
      setActiveIndex(2);
      return;
    }

    // const docUserType = getDocType(baseDataForm.doc);
    const docEnterpriseType = getDocType(baseDataForm.doc_enterprise);

    // const notification = toast.loading("Por favor aguarde...");
    setLoading(true);
    const [exp_month, exp_year] = cardMonthly.expiry.split("/");

    const obj = {
      doc: baseDataForm.doc_enterprise,
      type_doc: docEnterpriseType,
      type_interval: typeInterval.type,
      name: baseDataForm.name_enterprise,
      email: baseDataForm.email_enterprise,
      phone: baseDataForm.phone_enterprise,
      // invoice_due_date: bestDay,
      users: baseDataForm.doc.map((doc, index) => {
        const user = {
          doc: doc,
          name: baseDataForm.name[index],
          email: baseDataForm.email[index],
          type_doc: 1,
        };
        if (index === 0) {
          user.password = baseDataForm.password;
          user.password_confirmation = baseDataForm.password;
        }
        return user;
      }),
      addresses: {
        cep: baseDataForm.cep,
        address: baseDataForm.address,
        num: baseDataForm.num,
        neighborhood: baseDataForm.neighborhood,
        city: baseDataForm.city,
        state: baseDataForm.state,
        complement: baseDataForm.complement,
        lat: baseDataForm.lat,
        lng: baseDataForm.lng,
      },
      plan_id: plan.plan.id,
      interval_id: plan.interval.id,
      slug: localStorage.getItem("slug") ?? null,
    };

    if (appliedCoupon) {
      obj.cupom = appliedCoupon.name;
    }

    if (bestDay) {
      obj.invoice_due_date = bestDay;
    }

    if (typeInterval.type === "month") {
      if (paymentMethod === "card" || paymentMethod === "installment") {
        obj.payment_subscription_fee = {
          payment_method: "credit_card",
          installments: form.getValues().installments
            ? form.getValues().installments
            : 1,
          holder_name: cardMonthly.name,
          card_number: cardMonthly.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvv: cardMonthly.cvc,
          ...creditCardClient.data,
          billing_address: {
            ...creditCardClient.address,
          },
        };

        // obj.payment_month = {
        //   payment_method: "credit_card",
        //   holder_name: cardMonthly.name,
        //   card_number: cardMonthly.card_number,
        //   exp_month: exp_month,
        //   exp_year: exp_year,
        //   cvv: cardMonthly.cvc,
        //   ...creditCardClient.data,
        //   billing_address: {
        //     ...creditCardClient.address,
        //   },
        // };
      }

      if (paymentMethod === "pix") {
        obj.payment_subscription_fee = {
          payment_method: "pix",
          customer_name: pixClient.customer_name,
          customer_email: pixClient.customer_email,
          customer_doc: pixClient.customer_doc,
          customer_phone: pixClient.phone_pix,
        };

        // obj.payment_month = {
        //   payment_method: "credit_card",
        //   holder_name: cardMonthly.name,
        //   card_number: cardMonthly.card_number,
        //   exp_month: exp_month,
        //   exp_year: exp_year,
        //   cvv: cardMonthly.cvc,
        //   ...creditCardClient.data,
        //   billing_address: {
        //     ...creditCardClient.address,
        //   },
        // };
      }
    }

    if (typeInterval.type === "year") {
      if (paymentMethod === "card" || paymentMethod === "installment") {
        obj.payment = {
          payment_method: "credit_card",
          installments: form.getValues().installments
            ? form.getValues().installments
            : 1,
          holder_name: cardMonthly.name,
          card_number: cardMonthly.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvv: cardMonthly.cvc,
          ...creditCardClient.data,
          billing_address: {
            ...creditCardClient.address,
          },
        };
      }

      if (paymentMethod === "pix") {
        if (
          pixClient.phone_pix &&
          pixClient.customer_name &&
          pixClient.customer_email &&
          pixClient.customer_doc
        ) {
          obj.payment = {
            payment_method: "pix",
            customer_name: pixClient.customer_name,
            customer_email: pixClient.customer_email,
            customer_doc: pixClient.customer_doc,
            customer_phone: pixClient.phone_pix,
          };
        } else {
          toast.warning("Preencha todos os campos!");
          setLoadingButton(false);
          return;
        }
      }
    }

    //  console.log("Obj Final: ", obj);

    try {
      const response = await postCreateAccount(obj);
      // console.log(response);
      //Lógica para receber o response e abrir o QRCode do PIX
      if (response.code) {
        setLoading(false);
        toast.error(
          "Ocorreu um erro ao enviar os dados, verifique seus dados de pagamento"
        );
        // toast.update(notification, {
        //   render: "Ocorreu um erro ao enviar os dados",
        //   autoClose: 5000,
        //   type: "error",
        //   isLoading: false,
        // });
        navigate("/");
        setLoadingButton(false);
        return;
      }

      if (response.success.link_QRcode) {
        setLoading(false);
        setPixDataQR({
          id: response.success.payment_id,
          copy: response.success.pix,
          qr_code: response.success.link_QRcode,
          timer: 7,
        });
        setVisiblePixPayment(true);
        return;
      }

      if (response.success.payment_id) {
        // toast.update(notification, {
        //   render: "Cadastro efeituado com sucesso",
        //   autoClose: 5000,
        //   type: "success",
        //   isLoading: false,
        // });
        toast.success("Cadastro efetuado com sucesso");
        setLoading(false);
        localStorage.removeItem("formData");
        navigate(`/success`, {
          state: {
            email: obj.email,
            idPayment: response.success.payment_id,
            pixPayment: paymentMethod === "pix",
            plan: plan,
          },
        });
        return;
      }

      // console.log(response);
      toast.success("Cadastro efetuado com sucesso");
      // toast.update(notification, {
      //   render: "Cadastro efeituado com sucesso",
      //   autoClose: 5000,
      //   type: "success",
      //   isLoading: false,
      // });
      setLoading(false);
      navigate(`/success`, {
        state: { email: obj.email },
      });
      // navigate(`/`);
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response.data?.errors?.doc
          ? "Documento Inválido, adicione um CPF ou CNPJ válido"
          : "Ocorreu um erro ao enviar os dados"
      );
      // toast.update(notification, {
      //   render: error.response.data?.errors?.doc
      //     ? "Documento Inválido, adicione um CPF ou CNPJ válido"
      //     : "Ocorreu um erro ao enviar os dados",
      //   autoClose: 5000,
      //   type: "error",
      //   isLoading: false,
      // });
    }
    setLoadingButton(false);
  };

  const handleFreeSubmit = async (plan) => {
    //    console.log(plan);
    //    console.log(cardState);
    //    console.log(pixClient);
    //    console.log(cardMonthly);
    //    console.log(baseDataForm);
    //    console.log(cardInstallment);
    //    console.log(creditCardClient);
    //    console.log(form.getValues());

    setLoadingButton(true);

    if (
      !baseDataForm ||
      isFormIncomplete({
        doc: baseDataForm.doc_enterprise,
        name: baseDataForm.name_enterprise,
        email: baseDataForm.email_enterprise,
        phone: baseDataForm.phone_enterprise,
        userDoc: baseDataForm?.doc[0],
        userName: baseDataForm?.name[0],
        userEmail: baseDataForm?.email[0],
        userPassword: baseDataForm?.password,
      })
    ) {
      toast.warning("Preencha os dados de cadastro");
      setActiveIndex(0);
      setLoadingButton(false);
      return;
    }

    if (!plan) {
      toast.warning("Por favor, selecione um plano!");
      setLoadingButton(false);
      setActiveIndex(2);
      return;
    }

    const isValidCPF = (doc) => {
      const cleanedDoc = doc.replace(/\D/g, "");
      return cleanedDoc.length === 11;
    };

    const isValidCNPJ = (doc) => {
      const cleanedDoc = doc.replace(/\D/g, "");
      return cleanedDoc.length === 14;
    };

    const getDocType = (doc) => {
      if (isValidCPF(doc)) return 1;
      if (isValidCNPJ(doc)) return 2;
      return null;
    };

    setLoading(true);
    const docEnterpriseType = getDocType(baseDataForm.doc_enterprise);

    const obj = {
      doc: baseDataForm.doc_enterprise,
      type_doc: docEnterpriseType,
      type_interval: "month",
      name: baseDataForm.name_enterprise,
      email: baseDataForm.email_enterprise,
      phone: baseDataForm.phone_enterprise,
      // invoice_due_date: bestDay,
      users: baseDataForm.doc.map((doc, index) => {
        const user = {
          doc: doc,
          name: baseDataForm.name[index],
          email: baseDataForm.email[index],
          type_doc: 1,
        };
        if (index === 0) {
          user.password = baseDataForm.password;
          user.password_confirmation = baseDataForm.password;
        }
        return user;
      }),
      addresses: {
        cep: baseDataForm.cep,
        address: baseDataForm.address,
        num: baseDataForm.num,
        neighborhood: baseDataForm.neighborhood,
        city: baseDataForm.city,
        state: baseDataForm.state,
        complement: baseDataForm.complement,
        lat: baseDataForm.lat,
        lng: baseDataForm.lng,
      },
      plan_id: plan.plan.id,
      interval_id: plan.interval.id,
      slug: localStorage.getItem("slug") ?? null,
    };
    //  console.log("Obj Final: ", obj);

    try {
      const response = await postCreateAccount(obj);
      // console.log(response);

      toast.success("Cadastro efetuado com sucesso");
      setLoading(false);
      navigate(`/verify`, { state: { environment_id: response.success.data } });
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response.data?.errors?.doc
          ? "Documento Inválido, adicione um CPF ou CNPJ válido"
          : "Ocorreu um erro ao enviar os dados"
      );
    }
    setLoadingButton(false);
  };

  const validateCupom = async (cupom, setLoading) => {
       console.log(cupom);
    setLoading(true);
    // const notification = toast.loading("Por favor aguarde...");
    try {
      const response = await getValidateCupom(cupom, typeInterval.id);
      if (response.cupom !== false) {
        setAppliedCoupon(response.cupom);
        form.clearErrors("cupom");
        setErrorCupom(false);
      } else {
        form.setError("cupom");
        setErrorCupom(true);
      }
    } catch (e) {
      form.setError("cupom");
      setErrorCupom(true);
    }
    setLoading(false);
  };

  return (
    <CreateAccountContext.Provider
      value={{
        form,
        plan,
        cupom,
        bestDay,
        setPlan,
        loading,
        setCupom,
        contract,
        onSubmit,
        savePlan,
        pixClient,
        cardState,
        pixDataQR,
        setBestDay,
        errorCupom,
        setLoading,
        setContract,
        cardMonthly,
        activeIndex,
        typeInterval,
        setPixClient,
        handleSubmit,
        setCardState,
        baseDataForm,
        setPixDataQR,
        appliedCoupon,
        loadingButton,
        validateCupom,
        paymentMethod,
        setErrorCupom,
        setCardMonthly,
        setActiveIndex,
        setTypeInterval,
        cardInstallment,
        setBaseDataForm,
        isFormIncomplete,
        creditCardClient,
        handleFreeSubmit,
        setAppliedCoupon,
        handleInputFocus,
        setPaymentMethod,
        visiblePixPayment,
        handleInputChange,
        creditCardSelected,
        setCardInstallment,
        handleMonthlyFocus,
        handleMonthlyChange,
        setCreditCardClient,
        setVisiblePixPayment,
        setCreditCardSelected,
        visiblePaymentMethods,
        handleInstallmentFocus,
        handleInstallmentChange,
        setVisiblePaymentMethods,
      }}
    >
      {children}
    </CreateAccountContext.Provider>
  );
}

export function useCreateAccountContext() {
  return useContext(CreateAccountContext);
}
